import { useEffect, useRef, useState } from 'react'

import { Tooltip } from '@mui/material'

function readTextContent(node) {
  if (!node) return ''
  if (typeof node === 'string' || typeof node === 'number') return String(node)
  if (node.textContent != null) return node.textContent
  return ''
}

function TruncatedCell({ children, maxWidth }) {
  const ref = useRef(null)
  const [isOverflowing, setIsOverflowing] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return undefined

    const measure = () => {
      const overflowing =
        el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1
      setIsOverflowing(overflowing)
    }

    measure()

    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measure) : null
    if (observer) observer.observe(el)
    window.addEventListener('resize', measure)

    return () => {
      if (observer) observer.disconnect()
      window.removeEventListener('resize', measure)
    }
  }, [children])

  const truncatedStyle = {
    display: 'block',
    maxWidth: maxWidth || '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    minWidth: 0,
  }

  const text = readTextContent(children)

  return (
    <Tooltip
      title={text}
      placement="top"
      arrow
      enterDelay={300}
      disableHoverListener={!isOverflowing || !text}
      disableFocusListener={!isOverflowing || !text}
      disableTouchListener={!isOverflowing || !text}
    >
      <span ref={ref} style={truncatedStyle}>
        {children}
      </span>
    </Tooltip>
  )
}

export default TruncatedCell
